import chroma from 'chroma-js';

export function readableTextColor(background) {
	try {
		return chroma.contrast(background, '#FFFFFF') > chroma.contrast(background, '#10110F')
			? '#FFFFFF'
			: '#10110F';
	} catch (error) {
		return '#10110F';
	}
}
